
import { SolutionProps } from './SolutionCard';
import SolutionCard from './SolutionCard';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';
import GoldSectionDivider from '@/components/ui/gold-section-divider';

interface SolutionsSectionProps {
  solutions: SolutionProps[];
}

const SolutionsSection = ({
  solutions
}: SolutionsSectionProps) => {
  return (
    <section aria-labelledby="solutions-heading" className="py-12 md:py-16 bg-neutral-100 rounded-none"> {/* Removed animate-on-view */}
      <div className="container mx-auto px-4">
        <div className="flex flex-col items-center mb-8">
          <GoldSectionDivider centered />
          <h2 id="solutions-heading" className="text-center text-boundri-DEFAULT mb-6">Our Solutions</h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {solutions.map(solution => <SolutionCard key={solution.id} solution={solution} />)}
        </div>
      </div>
    </section>
  );
};

export default SolutionsSection;
